import dayjs from 'dayjs'

export const getTimeFromDate = (date: Date) => {
  return dayjs(date).format('hh:mm A')
}
